import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Logo } from '../components/Logo';
import { Footer } from '../components/Footer';
import { PasswordInput } from '../components/PasswordInput';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { updatePassword } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    setSubmitting(true);
    const { error } = await updatePassword(password);
    setSubmitting(false);
    if (error) { toast.error(error.message); return; }
    toast.success('Password updated');
    // Honor a sanitized "next" param so ClickFunnels opt-ins land on the welcome
    // wizard. Only allow same-origin relative paths.
    const next = params.get('next');
    const safeNext = next && next.startsWith('/') && !next.startsWith('//') ? next : '/today';
    navigate(safeNext, { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col relative z-10" data-testid="reset-page">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-primary mb-8 flex justify-center"><Logo /></div>
        <div className="rounded-2xl border border-border bg-card p-7 sm:p-9">
          <h1 className="font-heading text-2xl font-semibold tracking-tight">Set a new password</h1>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="password">New password</Label>
              <PasswordInput id="password" required value={password} onChange={(e) => setPassword(e.target.value)} testid="reset-password" />
            </div>
            <Button type="submit" disabled={submitting} className="w-full rounded-full" data-testid="reset-submit">
              {submitting && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
              Update password
            </Button>
          </form>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
}
